import React, { Component } from 'react';

import {reduxForm, Field} from 'redux-form';
import { withRouter } from 'react-router';
import { HotKeys } from "react-hotkeys";
import axios from "axios";

import StatesList from '../containers/StatesContainer.js';
import EmploymentsList from '../containers/EmploymentsContainer.js';
import AssociateTypesList from "../containers/AssociateTypeContainer";
import CustomAlert from '../components/CustomAlert.js';
import asyncValidate from './Validations/asyncValidationsMainForm';
import RenderField from './RenderField';
import SelectField from './SelectField';
import CustomSpinner from './CustomSpinner';


class MainForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
            initialForm: true,
            resources: []
        };
    }

    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/subscribers/process`, config)
            .then(response => {
                this.setState({
                    resources: response.data.fields,
                    initialForm: false
                });
            }).catch(error => {
                this.setState({
                    initialForm: true
                });
            });
    }

    getEmail = () => {
        return (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="email" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('email') ? 'hidden' : 'email'} label="Correo Electrónico" showSuccess={true} />
                </div>
            </div>
        );
    }

    checkField = (field) => {
        return this.state.resources.includes(field);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        const initialForm = this.state.initialForm;

        const sellerCodeField = (
            <div className={'row'}>
                <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                        <Field className="form-control" name="seller_code" autoComplete="off" component={RenderField} type={'text'} label="Código"  />
                    </div>
                </div>
            </div>
        );

        let email = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="email" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('email') ? 'hidden' : 'email'} label="Correo Electrónico" showSuccess={true} />
                </div>
            </div>
        );

        const document_number = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="document_number" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('document_number') ? 'hidden' : 'number'} label="Número de Documento" />
                </div>
            </div>
        );

        const fullname = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="name" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('name') ? 'hidden' : 'text'} label="Nombre y Apellido" />
                </div>
            </div>
        );

        const gender = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field
                        className="form-control"
                        name="gender"
                        autoComplete="off"
                        component={SelectField}
                        options={[{id: 'm', name: 'Masculino'}, {id: 'f', name: 'Femenino'}]}
                        defaultValue={'Sexo según tu DNI'}
                        label={'Género'}
                        type={this.state.fields.hasOwnProperty('gender') ? 'hidden' : 'select'}
                    />
                </div>
            </div>
        );

        const area_code = (
            <div className="col-md-4 col-lg-4">
                <div className="form-group">
                    <Field className="form-control" name="area_code" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('area_code') ? 'hidden' : 'number'} label="Código de Area" showSuccess={true} />
                </div>
            </div>
        );

        const number = (
            <div className="col-md-8 col-lg-8">
                <div className="form-group">
                    <Field className="form-control" name="number" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('number') ? 'hidden' : 'number'} label="Número de Celular" showSuccess={true} />
                </div>
            </div>
        );

        let employments = null;
        if (false){
            employments = <EmploymentsList type={this.state.fields.hasOwnProperty('employment_id') ? 'hidden' : 'select'} />;
        }

        let states = null;
        if (this.checkField('state_id') || this.state.initialForm){
            states = <StatesList type={this.state.fields.hasOwnProperty('state_id') ? 'hidden' : 'select'} />;
        }

        let associate_type = null;
        if (this.checkField('associate_type_id')){
            associate_type = <AssociateTypesList type={this.state.fields.hasOwnProperty('associate_type_id') ? 'hidden' : 'select'} />;;
        }

        return (
            <HotKeys handlers={{SHOW_SELLER_CODE: this.showCodeField}}>
            <div>
                <form onSubmit={handleSubmit(this.props.addSubscriber)} className='pvc-form'>
                    {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                    {error && <CustomAlert bsStyle="danger" message={error}/>}
                    <div className={this.state.fields.hasOwnProperty('email') && this.state.fields.hasOwnProperty('document_number') ? 'row-hidden' : 'row' }>
                        {initialForm ? email : (this.checkField('email') ? email : null)}
                        {initialForm ? document_number : (this.checkField('document_number') ? document_number : null)}
                    </div>
                    <div className={this.state.fields.hasOwnProperty('name') && this.state.fields.hasOwnProperty('gender') ? 'row-hidden' : 'row' }>
                        {initialForm ? fullname : (this.checkField('name') ? fullname : null)}
                        {initialForm ? gender : (this.checkField('gender') ? gender : null)}
                    </div>
                    <div className={this.state.fields.hasOwnProperty('area_code') && this.state.fields.hasOwnProperty('number') ? 'row-hidden' : 'row' }>
                        {initialForm ? area_code : (this.checkField('area_code') ? area_code : null)}
                        {initialForm ? number : (this.checkField('number') ? number : null)}
                    </div>
                    <div className={this.state.fields.hasOwnProperty('associate_type_id') ? 'row-hidden' : 'row'}>
                        {associate_type}
                    </div>
                    <div className={this.state.fields.hasOwnProperty('employment_id') && this.state.fields.hasOwnProperty('state_id') ? 'row-hidden' : 'row' }>
                        {employments}
                        {states}
                    </div>
                    <div>
                        <Field className="form-control" name="site" autoComplete="off" component={RenderField} type="hidden" />
                        <Field className="form-control" name="employment_id" autoComplete="off" component={RenderField} type="hidden" />
                    </div>
                    { ( this.state.showCodeField || this.props.sellerCode ) && sellerCodeField }
                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Solicitar</button>
                </form>
            </div>
            </HotKeys>
        );
    }
}

MainForm = reduxForm({
    initialValues: {
        site: ((process.env.PAGE === 'montemar' && 'Montemar.com.ar') ||
               (process.env.PAGE === 'montemar-adelantos' && 'Adelantos.montemar.com.ar') ||
               (process.env.PAGE === 'puedo' && 'Puedo.com.ar') ||
               (process.env.PAGE === 'amfa' && 'Mutualamfa.com.ar') ||
               (process.env.PAGE === 'juncal' && 'Juncal.com.ar') ||
               (process.env.PAGE === 'demo' && 'Demo-Creditos.com.ar')),
        employment_id: "10",
    },
    form: 'main', // a unique name for this form
    asyncValidate,
    asyncBlurFields: ['email', 'area_code', 'number']
})(MainForm);

MainForm = withRouter(MainForm);

export default MainForm;



/** WEBPACK FOOTER **
 ** ./src/components/MainForm.js
 **/